import { render } from "./FamulaturComponent.vue?vue&type=template&id=28c59b41&scoped=true&ts=true"
import script from "./FamulaturComponent.vue?vue&type=script&lang=ts"
export * from "./FamulaturComponent.vue?vue&type=script&lang=ts"

import "./FamulaturComponent.vue?vue&type=style&index=0&id=28c59b41&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c59b41"]])

export default __exports__